export interface StylePositionRef {
  partName: string;
  elementName: string;
  styleName: string;
}

export interface ElementSelectionRef {
  partName: string;
  elementName: string;
}

export function getStylePositionKey(
  partName: string,
  elementName: string,
  styleName: string
): string {
  return `${partName}::${elementName}::${styleName}`;
}

export function parseStylePositionKey(key: string): StylePositionRef {
  const [partName = "", elementName = "", styleName = ""] = key.split("::");
  return { partName, elementName, styleName };
}

export function getElementSelectionKey(
  partName: string,
  elementName: string
): string {
  return `${partName}::${elementName}`;
}

export function parseElementSelectionKey(key: string): ElementSelectionRef {
  const [partName = "", elementName = ""] = key.split("::");
  return { partName, elementName };
}
